import {useSelector} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {getIsPasswordProtectedForm, isNotEmpty, isObjectNotEmpty,} from "../../Utils";
import {getApplicantFormList, getSelectedUserOrg, getUserRole,} from "../../redux/selector";
import Forbidden from "../Forbidden/Forbidden";
import PasswordGuard from "../PasswordGuard/PasswordGuard";

export default function Auth({
    children,
    roles,
    annoAccess = false,
    byList = false,
}) {
    const role = useSelector(getUserRole());
    const { pathname, search } = useLocation();
    const applicantFormList = useSelector(getApplicantFormList());
    const query = new URLSearchParams(search);
    const selectedUserOrg = useSelector(getSelectedUserOrg());

    const onList = () => {
        const rawFormId = pathname.replace("/", "");
        // DraftManage 页面使用对应表单的权限
        const formId = rawFormId === "Form107DraftManage" ? "Form107" : rawFormId;
        const result = applicantFormList.some((e) => e.url === formId);

        return result;
    };
    const returnOnListChildren = () => {
        const formId = pathname.replace("/", "");
        if (getIsPasswordProtectedForm(formId)) {
            return <PasswordGuard>{children}</PasswordGuard>;
        } else {
            return children;
        }
    };

    // if (
    //     pathname.replace("/Form", "") === "088"
    //     //|| pathname.replace("/Form", "") === "105"
    // ) {
    //     return <PasswordGuard>{children}</PasswordGuard>;
    // }

    if (isObjectNotEmpty(roles)) {
        if (isNotEmpty(role)) {
            if (role !== "ANONYMOUS") {
                if (roles.includes(role)) {
                    return returnOnListChildren();
                } else {
                    return <Forbidden />;
                }
            } else if (annoAccess) {
                return children;
            } else {
                if (query.get("edbuserlogin") === "true") {
                    return (
                        <Navigate
                            to={`/edbuserlogin?redirect=${encodeURIComponent(
                                pathname
                            )}`}
                        />
                    );
                }
                return (
                    <Navigate
                        to={`/Login?redirect=${encodeURIComponent(pathname)}`}
                    />
                );
            }
        } else {
            return <></>;
        }
    } else if (byList) {
        if (isNotEmpty(role)) {
            if (role !== "ANONYMOUS") {
                if (
                    isNotEmpty(selectedUserOrg) &&
                    isNotEmpty(applicantFormList)
                ) {
                    if (onList()) {
                        return returnOnListChildren();
                    } else {
                        return <Forbidden />;
                    }
                } else {
                    return <></>;
                }
            } else if (annoAccess) {
                return returnOnListChildren();
            } else {
                if (query.get("edbuserlogin") === "true") {
                    return (
                        <Navigate
                            to={`/edbuserlogin?redirect=${encodeURIComponent(
                                pathname
                            )}`}
                        />
                    );
                }
                return (
                    <Navigate
                        to={`/Login?redirect=${encodeURIComponent(pathname)}`}
                    />
                );
            }
        } else {
            return <></>;
        }
    } else {
        return children;
    }
}
